import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat, YoutubeFormatHelper } from '../../../../../../../utils/youtube-format-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * In-feed ad on a Google video partner site — the same video creative as the
 * in-stream placement, but sitting in the publisher's feed as a card rather
 * than taking the page over. The 16:9 placement.
 */
@Component({
    selector: 'app-gen-video-partners-in-feed-mobile',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './video-partners-in-feed-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './video-partners-in-feed-mobile.component.scss'
})
export class VideoPartnersInFeedMobilePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  /** The creative format this placement previews, found by measured ratio. */
  readonly format: VideoFormat = '16:9';

  /** Thumbnail of the 16:9 video, or '' when there isn't one yet. */
  get thumbnailUrl(): string {
    return YoutubeFormatHelper.thumbnailForFormat(this.videoIds, this.format);
  }

  /**
   * True while any link is still being measured, so the empty slot says so
   * rather than asking for a video that is about to turn up.
   */
  get isResolving(): boolean {
    return YoutubeFormatHelper.isResolvingAny(this.videoIds);
  }

  /**
   * One bold line beside the logo, so it takes the short headline and only
   * falls back to the long one when there isn't one.
   */
  get headline(): string {
    return this.data.headlines[0] || this.data.longHeadlines[0] || 'Your headline appears here';
  }

  private get videoIds(): string[] {
    return this.data.videos.map((video) => video.videoId);
  }
}
